module.exports = __webpack_public_path__ + "f104c4a4.svg";